module.exports = __webpack_public_path__ + "img/trump_margin_filter_selected.e4c61cff.png";